import GalaxyChest from '../../assets/images/chests/preview/galaxy-chest.png';
import LaunchChest from '../../assets/images/chests/preview/launch-chest.png';
import OrbitChest from '../../assets/images/chests/preview/orbit-chest.png';
import SupernovaChest from '../../assets/images/chests/preview/supernova-chest.png';
import GalaxyChestGlow from '../../assets/svg/chests/glows/galaxy-glow.svg';
import LaunchChestGlow from '../../assets/svg/chests/glows/launch-glow.svg';
import LaunchChestShine from '../../assets/svg/chests/shines/launch-shine.svg';
import OrbitChestGlow from '../../assets/svg/chests/glows/orbit-glow.svg';
import OrbitChestShine from '../../assets/svg/chests/shines/orbit-shine.svg';
import SupernovaChestGlow from '../../assets/svg/chests/glows/supernova-glow.svg';

import { TChestVariant } from '../../types';

type TChestIconClassName = {
  wrapper?: string;
  icon?: string
}

type TGetChestIconOptions = {
    glow?: boolean;
    shine?: boolean;
    classNames?: {
      shine?: TChestIconClassName;
      chest?: TChestIconClassName;
      glow?: TChestIconClassName;
      wrapper?: string;
    }
}

export const getChestIcon = (variant: TChestVariant, options?: TGetChestIconOptions) => {
  let chest = null;
  let glow = null;
  let shine = null;

  switch (variant) {
    case 'supernova':
      chest = <img src={SupernovaChest} alt={variant} className={options?.classNames?.chest?.icon} />;

      if (options?.glow) {
        glow = <img src={SupernovaChestGlow} alt="supernova-chest-glow" className={`${options?.classNames?.glow?.icon} w-full h-full`} />;
      }

      if (options?.shine) {
        shine = <img src={OrbitChestShine} alt="orbit-chest-shine" className={`${options?.classNames?.shine?.icon} w-full h-full`} />;
      }

      break;
    case 'galaxy':
      chest = <img src={GalaxyChest} alt={variant} className={options?.classNames?.chest?.icon} />;

      if (options?.glow) {
        glow = <img src={GalaxyChestGlow} alt="galaxy-chest-glow" className={`${options?.classNames?.glow?.icon} w-full h-full`} />;
      }

      if (options?.shine) {
        shine = <img src={OrbitChestShine} alt="orbit-chest-shine" className={`${options?.classNames?.shine?.icon} w-full h-full`} />;
      }

      break;
    case 'orbit':
      chest = <img src={OrbitChest} alt={variant} className={options?.classNames?.chest?.icon} />;

      if (options?.glow) {
        glow = <img src={OrbitChestGlow} alt="orbit-chest-glow" className={`${options?.classNames?.glow?.icon} w-full h-full`} />;
      }

      if (options?.shine) {
        shine = <img src={OrbitChestShine} alt="orbit-chest-shine" className={`${options?.classNames?.shine?.icon} w-full h-full`} />;
      }

      break;
    default:
      chest = <img src={LaunchChest} alt={variant} className={options?.classNames?.chest?.icon} />;

      if (options?.glow) {
        glow = <img src={LaunchChestGlow} alt="launch-chest-glow" className={`${options?.classNames?.glow?.icon} w-full h-full`} />;
      }

      if (options?.shine) {
        shine = <img src={LaunchChestShine} alt="launch-chest-shine" className={`${options?.classNames?.shine?.icon} w-full h-full`} />;
      }
  }

  return (
    <div className={`${options?.classNames?.wrapper} absolute inset-0 w-full h-full`}>
      <div
        className={options?.classNames?.chest?.wrapper ?? `
          absolute
          top-[50%]
          left-[50%]
          transform translate-y-[-50%] translate-x-[-50%]
          w-[90%]
          flex items-center justify-center
          z-[2]  
        `}
      >
        {chest}
      </div>
      {shine && (
      <div
        className={options?.classNames?.shine?.wrapper ?? `
            absolute
            top-[50%] left-[50%]
            transform translate-x-[-50%] translate-y-[-50%]
            z-[-1]
            w-full h-full
        `}
      >
        {shine}
      </div>
      )}
      {glow && (
      <div
        className={options?.classNames?.glow?.wrapper ?? `
          absolute
          inset-0
        `}
      >
        {glow}
      </div>
      )}
    </div>
  );
};
